import React from 'react';
const CardList = ({ data }) => {
  return (
    <div className="flex-1 min-w-[300px] lg:w-1/2 z-10 py-10 bg- mt-8 bg-white">

    <div className="space-y-6 flex flex-col lg:pl-24 ">
      {data.map((item, index) => (
        <div key={index} className="bg-gray-200 p-4 sm:py-6 md:p-6 lg:p-10 rounded-lg card-border border-gray-500">
          <h2 className={`text-base md:text-base lg:text-2xl font-bold mb-2 text-primary`}>
            I {item.title.split(' ')[1]} <span className={`text-${item.color}`}>{item.highlight}</span>, {item.title.split(', ')[1]}
          </h2>
          <p className='text-gray-500 text-sm md:text-sm lg:text-base'>{item.description}</p>
        </div>
      ))}
    </div>
    </div>
  );
};

export default CardList;
